import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html'
})
export class FAQComponent implements OnInit {

	title: string;
	header: any;
	headerHeight: any;
  headerAlign: any;
	subtitle: string;

  constructor(private sanitizer : DomSanitizer) { }


  easter(e) {
    console.log(e);
  }

  // $('.faq-section h5').click( function(e) {
  //   $(this).hasClass('changed');
  // })

  /* On with the show */
  ngOnInit() {
    this.title = 'FREQUENT QUESTIONS';
    this.headerHeight = '600px';
    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-faq.jpg") bottom' );
    this.subtitle = 'Answers to the most commonly asked questions.';
  }

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/faq/faq.component.ts